export default __webpack_public_path__ + "media/zurb/img/playground/lord-kelvin-3f0b1b4c24e8f9af1ddaceadcf49981a.jpg";